//imports
import {
    CANNEDCOMMAND_DELETE_OPEN_MODAL,
    CANNEDCOMMAND_DELETE_REQUEST,
    CANNEDCOMMAND_DELETE_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
    cannedCommand: null,
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CANNEDCOMMAND_DELETE_OPEN_MODAL:
            return { ...state, openModal: true, cannedCommand: action.payload }

        case CANNEDCOMMAND_DELETE_REQUEST:
            return { ...state, loading: true }

        case CANNEDCOMMAND_DELETE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "DELETE_CANNEDCOMMANDS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
